import { api } from "./configs/axiosConfigs";

export const GroupActivityD1API = {
    getGroupActivityD1: async (data?: any) => {
        const response = await api
            .get('/groupActivityD1', { params: { ...data } })
            .then(response => response.data)
            .catch((error) => {
                return error.response.data
            });
        return response;
    }
}